<template>
  <div class="bannerBox" :style="bannerStyle">
    <div class="swiper-container bannerSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
          <a
            v-if="item.urlType == 1"
            :href="item.url"
            target="_blank"
            :title="item.title"
          >
            <img class="swiper_img" :src="item.fileName" style="width: 100% ; height: 100% ;" />
          </a>
          <a
            v-if="item.urlType == 2"
            :href="`/list/${item.url}`"
            target="_blank"
            :title="item.title"
          >
            <img class="swiper_img" :src="item.fileName" style="width: 100% ; height: 100% ;" />
          </a>
          <a
            v-if="item.urlType == 3"
            :href="`/detail/${0}/${item.url}`"
            target="_blank"
            :title="item.title"
          >
            <img class="swiper_img" :src="item.fileName" style="width: 100% ; height: 100% ;" />
          </a>
          <a v-if="item.urlType == 4" :title="item.title">
            <img class="swiper_img" :src="item.fileName" style="width: 100% ; height: 100% ;" />
          </a>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper"
import { getAdvert } from '@/api/common'
export default {
  props: {
    height: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      bannerList: [],
      bannerStyle: {}
    }
  },
  mounted() {
    var _this = this

    _this.bannerStyle = {
      height: _this.height + 'vh'
    }
    _this.bannerSwiper()
  },
  methods: {
    bannerSwiper(){
      var _this = this
      let data = {
        applicationUuid: _this.webId,
        advertType: 1
      }
      getAdvert(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          data.length && data.forEach(line => {
            if (line.fileName && line.fileName !== '') {
              _this.bannerList.push(line)
            }
          })
          this.$nextTick(() => {
            new Swiper(".bannerSwiper", {
              effect : 'fade',
              loop: true,
              speed: 300,
              autoplay: 2000,
              updateOnImagesReady: true,
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              autoplayDisableOnInteraction: false,
              pagination : '.swiper-pagination',
              paginationClickable :true,

             
            })
          })
        }
      })
    },
  }
}
</script>
<style>
.bannerBox{
  width: 100%;
  /*max-width: 1920px; */
  margin: 0 auto;
}
.bannerSwiper {
  height: 100%;
}
.bannerBox .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
}

</style>